import { motion } from "framer-motion";
import SectionHeader from "@/components/SectionHeader";
import { WHY_CHOOSE } from "@/data/site";

export default function WhyChoose() {
  return (
    <section className="relative bg-white py-24 sm:py-32" data-testid="why-choose-section">
      <div className="container-x">
        <SectionHeader
          overline="Why NEPHRC"
          title={<>Eight commitments<br />we make to <span className="text-emerald-brand">every</span> client.</>}
          subtitle="What clients notice first is our craft; what they remember is our discipline. Here is how we work — and why it matters."
        />

        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-slate-200">
          {WHY_CHOOSE.map((item, i) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.45, delay: (i % 4) * 0.04 }}
              className="bg-white p-8 hover:bg-mist transition-colors"
            >
              <div className="font-mono-alt text-xs text-emerald-brand">
                {String(i + 1).padStart(2, "0")}.
              </div>
              <h3 className="mt-4 font-display font-bold text-lg text-navy leading-tight">
                {item.title}
              </h3>
              <p className="mt-3 text-sm text-slate-brand leading-relaxed">
                {item.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
